const aboutData = {
  intro: {
    heading: "Welcome to Spice Garden",
    image: "../assets/images/indian-restaurant-interior.jpg",
    paragraphs: [
      "Since 2010, Spice Garden has been serving authentic Indian cuisine with a commitment to quality, tradition, and exceptional hospitality. Our journey began with a simple vision: to bring the rich culinary heritage of India to food lovers everywhere.",
      "Led by Master Chef Rajesh Kumar, who trained in the royal kitchens of Rajasthan, our team brings over 20 years of culinary expertise to every dish. We use traditional cooking methods, hand-ground spices, and recipes passed down through generations to create an authentic dining experience.",
      "From the aromatic biryanis of Hyderabad to the rich curries of Punjab, from the coastal flavors of Kerala to the royal dishes of Rajasthan, we celebrate India's diverse culinary landscape under one roof.",
    ],
  },

  valuesSection: {
    title: "Our Values",
    subtitle: "The principles that guide everything we do",
    items: [
      {
        icon: "fas fa-bullseye",
        title: "Our Mission",
        text:
          "To serve authentic Indian cuisine that honors tradition while delighting modern palates, creating memorable dining experiences for every guest.",
      },
      {
        icon: "fas fa-eye",
        title: "Our Vision",
        text:
          "To be recognized as the premier destination for authentic Indian cuisine, setting the standard for quality, authenticity, and hospitality.",
      },
      {
        icon: "fas fa-heart",
        title: "Our Values",
        list: [
          "Authenticity in every dish",
          "Quality ingredients always",
          "Exceptional hospitality",
          "Respect for tradition",
        ],
      },
    ],
  },
};

export default aboutData;
